(function () {
  function formatCount(count) {
    return count.toLocaleString("en-US");
  }

  function parseCount(value) {
    if (value == null || value === "") return null;
    const parsed = Number(String(value).replace(/,/g, ""));
    return Number.isFinite(parsed) ? parsed : null;
  }

  function applyCount(el, count) {
    if (count == null) return;

    const formatted = formatCount(count);
    el.textContent = formatted;
    el.setAttribute("aria-label", `${formatted} GitHub stars`);

    const cta = el.closest(".announcement-bar__github-cta");
    if (cta) {
      cta.setAttribute("aria-label", `GitHub · ${formatted} stars`);
    }
  }

  async function starsFromShields(repo) {
    const response = await fetch(`https://img.shields.io/github/stars/${repo}.json`);
    if (!response.ok) throw new Error("shields.io unavailable");

    const data = await response.json();
    const count = parseCount(data.value ?? data.message);
    if (count == null) throw new Error("invalid shields.io response");
    return count;
  }

  document.querySelectorAll("[data-github-stars-count]").forEach((el) => {
    const repo = el.dataset.githubRepo;
    const fallback = parseCount(el.dataset.githubStarsFallback);
    const current = parseCount(el.textContent);
    const initial = current ?? fallback;

    if (initial != null) {
      applyCount(el, initial);
    }

    if (!repo) return;

    starsFromShields(repo)
      .then((count) => applyCount(el, count))
      .catch(() => {});
  });
})();
